const Wishlist = {
  storageKey: 'abaka_wishlist',

  getItems() {
    return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
  },

  saveItems(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.updateCounter();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items } }));
  },

  hasItem(productId) {
    return this.getItems().includes(String(productId));
  },

  toggle(productId) {
    const items = this.getItems();
    const id = String(productId);
    const index = items.indexOf(id);
    if (index === -1) {
      items.push(id);
    } else {
      items.splice(index, 1);
    }
    this.saveItems(items);
    return this.hasItem(id);
  },

  updateCounter() {
    const count = this.getItems().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  getShareUrl() {
    const ids = this.getItems().join(',');
    const url = new URL(window.location.origin + window.__wishlistPageUrl);
    if (ids) url.searchParams.set('shared', ids);
    return url.toString();
  },

  loadShared() {
    const params = new URLSearchParams(window.location.search);
    const shared = params.get('shared');
    if (shared) {
      const ids = shared.split(',').map(id => id.trim()).filter(Boolean);
      this.saveItems(ids);
    }
  },

  init() {
    this.loadShared();
    this.updateCounter();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const id = btn.dataset.wishlistToggle;
      btn.classList.toggle('is-active', this.hasItem(id));
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const active = this.toggle(id);
        btn.classList.toggle('is-active', active);
      }, true);
    });

    const link = document.getElementById('wishlist-header-link');
    if (link) {
      const match = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]{2})/);
      const prefix = match ? match[1] : '';
      link.href = prefix + '/pages/wishlist';
    }
  }
};

document.addEventListener('DOMContentLoaded', () => Wishlist.init());
